/* Oud Library: free 3ml roll-on from the sign-up pop-up (29 Sep 2026).
   The Omnisend sample pop-up asks "What are you drawn to?" first, then the email. When the visitor subscribes, this
   adds that scent family's free 3ml roll-on (the hidden £0 product "Free 3ml Parfum Oil Roll-On") to their basket,
   so they only pick once. Theme asset assets/ol-free-sample.js, loaded from layout/theme.liquid.
   The family comes from the Omnisend event's formValues if present, otherwise from the step-1 button they tapped. */
(function () {
  var FORMS = { '6abad543944878cf42ab3ad7': 1, '6abbd9add9a315cfaf2b17bc': 1, '6ad015a681f24508f2eb18b9': 1 }; // desktop, phones, Linktree (added 19 Oct 2026)
  var VARIANTS = { sample_oud: 57365859041545, sample_fresh: 57365859074313, sample_vanilla: 57365859107081, sample_spiced: 57365859139849 };
  var LABELS = { 'oud & woods': 'sample_oud', 'fresh & fruity': 'sample_fresh', 'sweet & vanilla': 'sample_vanilla', 'warm & spiced': 'sample_spiced' };
  var KEY = 'ol_free_sample_family';
  var chosen = null;

  function remember(v) { if (!VARIANTS[v]) return; chosen = v; try { sessionStorage.setItem(KEY, v); } catch (e) {} }
  function recall() { if (chosen) return chosen; try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function formIdOf(d) { return (d.form && (d.form.id || d.form.formID)) || d.formID || d.formId || ''; }
  function inOurForm(el) { for (var id in FORMS) { if (el.closest('[class*="omnisend-form-' + id + '"]')) return true; } return false; }
  function familyFrom(values) {
    if (!values) return null;
    var v = values.sample_family || (values.customProperties && values.customProperties.sample_family);
    return VARIANTS[v] ? v : null;
  }

  // Fallback: remember which family button was tapped on step 1.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button, [role="button"]') : null;
    if (!b || !inOurForm(b)) return;
    var v = LABELS[(b.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase()];
    if (v) remember(v);
  }, true);

  function addToBasket(v) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var already = (cart.items || []).some(function (i) { return /^FREE3ML-/.test(i.sku || ''); });
        if (already) { console.info('[ol-free-sample] already in basket'); return; }
        return fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: VARIANTS[v], quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) { console.warn('[ol-free-sample] add failed', r.status); return; }
          console.info('[ol-free-sample] added', v);
          document.dispatchEvent(new CustomEvent('ol:free-sample-added', { detail: { family: v } }));
          // Update the header basket count the same way ol-store.js does ([data-ol-cart-count]).
          return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r2) { return r2.json(); }).then(function (c) {
            document.querySelectorAll('[data-ol-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
          });
        });
      })
      .catch(function (err) { console.warn('[ol-free-sample]', err); });
  }

  window.addEventListener('omnisendForms', function (e) {
    var d = e.detail || {};
    if (!FORMS[formIdOf(d)]) return;
    var v = familyFrom(d.formValues);
    if (v) remember(v);
    if ((d.eventName || d.type) === 'submit') {
      v = v || recall();
      if (v) addToBasket(v); else console.warn('[ol-free-sample] no family recorded');
    }
  });
})();
